<template>
  <div class="auto-gam-resolution-tab">
    <div v-if="gamResolutionValues.length">
      <AutoGamResolutionTable
        :auto-gam-resolution-columns="autoGamResolutionColumns"
        :auto-gam-resolution-values="gamResolutionValues"
        :table-action-columns="tableActionColumns"
        :selected-rows="selectedRows"
        :selected-row-by-ids="selectedRowByIds"
        :active-row="activeRow"
        :is-gam-already-created="isGamIsAlreadyCreated"
        @updateActiveRow="updateActiveRow"
        @onMultiSelectRow="onMultiSelectRow"
        @getActionButtonText="getActionButtonText" />
      <div
        v-if="
          actionButtonText.length &&
          actionButtonText !=
            'No GAM - Manual exisiting process need to followed'
        "
        class="auto-gam-resolution-tab__action">
        <Button
          :label="actionButtonText"
          appearance="primary"
          icon="arrow-right"
          icon-position="right"
          :disabled="
            isGamIsAlreadyCreated || disableActionButton ? true : false
          "
          @onClick="onCreateGam" />
      </div>
    </div>
    <div v-else>Auto gam resolution data is not present</div>
  </div>
</template>

<script>
import {
  autoGamResolutionColumns,
  tableActionColumns,
} from "@/config/disputeDataConstant.js";
import AutoGamResolutionTable from "@/components/AutoGamResolution/AutoGamResolutionTable.vue";
import { showToast } from "@/components/common/Toast";
// Actions
import { disputeActions } from "@/actions";
import { gamActions } from "@/actions";
// Util
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalIdToken } from "@/utils/helpers";
import { REDIRECT_GAM_URI } from "@/config/constant.js";

export default {
  name: "AutoGamResolutionTab",
  components: {
    AutoGamResolutionTable,
  },
  props: {
    gamResolutionValues: {
      type: Array,
      default() {
        return [];
      },
    },
    isGamIsAlreadyCreated: {
      type: Boolean,
      default() {
        return false;
      },
    },
    caseDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      autoGamResolutionColumns,
      tableActionColumns,
      selectedRowByIds: [],
      selectedRows: [],
      activeRow: {},
      actionButtonText: "",
      disableActionButton: false,
    };
  },

  mounted() {
    this.selectedRowByIds = [
      ...this.selectedRowByIds,
      ...this.gamResolutionValues
        ?.filter((item) => {
          return item?.isPotentialAccept;
        })
        ?.map((item) => item?.charge_type),
    ];
  },
  methods: {
    updateActiveRow(row) {
      this.activeRow = row;
    },
    onMultiSelectRow(selectedItems) {
      this.selectedRows = [...selectedItems];
      if (this.selectedRows?.length) {
        this.selectedRowByIds = this.selectedRows.map(
          (item) => item.charge_type
        );
      } else {
        this.selectedRowByIds = [];
      }
    },
    async updateDispute(payload) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.updateDisputeFromSfdc(
            payload,
            this.caseDetails?.ohpDisputeId,
            await getMsalIdToken(this)
          )
        );
        showToast("success", `User preference successfully saved.`);
      } catch (error) {
        showToast(
          "error",
          err?.response?.data?.errorMessage || "Unable to save User preference"
        );
      }
    },

    async onCreateGam() {
      if (this.actionButtonText == "Create Manual GAM") {
        const {
          idTokenClaims: { EmployeeID: employeeId, name: userName },
        } = this.$store.getters.getTokenData;
        await Promise.allSettled([
          this.updateDispute({
            disputeStage: "In-Process",
            statusCode: "20",
            statusDescription: "In Process",
            processorName: `${employeeId}`,
            noteDescription: "Triggered partial GAM creation flow.",
            isAutoGamResolutionModal: false,
          }).then(async () => {
            this.$emit("mountDetailsData");
            const formGamRequestInfo = {
              invoiceNumber: this.caseDetails?.invoiceNumber,
              chargesInfo: this.gamResolutionValues
                ?.map((item) => {
                  return {
                    ...item,
                    expectedAmount: item?.expectedAmount.replaceAll("$", ""),
                  };
                })
                ?.filter((item) => {
                  return (
                    (item?.expectedQuantity >= 0 &&
                      item?.expectedAmount >= 0 &&
                      item?.outcome == "accept") ||
                    item?.isPotentialAccept
                  );
                }),
              gamType: "AB36",
              searchType: "I",
              type: "single",
              areaCode: this.caseDetails?.areaCode,
              areaName: this.caseDetails?.areaName,
              companyCode: this.caseDetails?.companyCode,
              businessAreaCode: this.caseDetails?.businessAreaCode,
              countryCode: this.caseDetails?.countryCode,
              countryName: this.caseDetails?.countryName,
              businessAreaDescription:
                this.caseDetails?.businessAreaDescription,
            };

            try {
              const { data } = await AxiosFetchForMsal(
                disputeActions.saveGamRequestDetails(
                  {
                    ohpDisputeId: this.caseDetails?.ohpDisputeId,
                    ohpGamRequest: JSON.stringify(formGamRequestInfo),
                  },
                  await getMsalIdToken(this)
                )
              );
              window
                .open(
                  `${REDIRECT_GAM_URI}gam-ticket-create?ohpDisputeId=${this.caseDetails?.ohpDisputeId}`,
                  "_blank"
                )
                .postMessage(
                  JSON.stringify(formGamRequestInfo),
                  `${REDIRECT_GAM_URI}gam-ticket-create?ohpDisputeId=${this.caseDetails?.ohpDisputeId}`
                );
              localStorage.setItem(
                "gamRequestDetails",
                JSON.stringify(formGamRequestInfo)
              );
            } catch (error) {}
          }),
        ]);
      } else {
        try {
          this.$emit("hideLoader");
          this.$emit("showLoader", "tabContainer");
          const algoProcessAutomationDetails =
            this.gamResolutionValues
              ?.filter((item) => item?.isPotentialAccept)
              ?.map((item) => {
                return {
                  chargeCode: item?.charge_type,
                  currentAmount: item?.currentAmount,
                  expectedAmount: item?.expectedAmount,
                  algoEvaluationComments: [],
                };
              }) || [];
          let createGamRequest = {
            event_type: "OHP_DV_CREATE_GAM",
            tenant: "DISPUTE",
            correlation: this.caseDetails?.ohpDisputeId,
            business_key: this.caseDetails?.ohpDisputeId,
            source_system: this.caseDetails?.createdSource,
            event_body: [
              {
                invoiceNumber: this.caseDetails?.invoiceNumber,
                ohpDisputeId: this.caseDetails?.ohpDisputeId,
                disputeSourceSystem: this.caseDetails?.createdSource,
                algoProcessAutomationDetails: algoProcessAutomationDetails,
              },
            ],
          };
          const { data } = await AxiosFetchForMsal(
            gamActions.initiateAutoGamCreateFlow(
              createGamRequest,
              `Bearer ${await getMsalIdToken(this)}`
            )
          );
          this.$emit("mountDetailsData");
          this.$emit("hideLoader");

          showToast("success", "Initiated Auto Create Gam successfully!");
        } catch (error) {
          this.$emit("hideLoader");
          showToast(
            "error",
            "Failed to initiate Auto Gam creation, Please try again."
          );
          console.error(error);
        }
      }
    },
    getActionButtonText(
      actionButtonText,
      disableActionButton,
      gamResolutionValues
    ) {
      this.actionButtonText = actionButtonText;
      this.disableActionButton = disableActionButton;
      this.gamResolutionValues = gamResolutionValues;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.auto-gam-resolution-tab {
  &__container {
    cursor: pointer;
    position: relative;
    margin-bottom: 16px;
  }
  &__action {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
